<template>
  <span class="mr-2">•</span>
</template>